<template>
  <v-card min-height="200" color="grey lighten-5" :hover="currSubStepInCron===1" >
    <v-card-title>
      <div class="headline  primary--text">
        <v-icon color="primary">{{$appConfig.date_time.icon}}</v-icon> {{cardInfo.title}} 
      </div>
      <v-flex xs12>
        <div class="mt-6 body-1 grey--text font-weight-light">{{cardInfo.text}} </div>
      </v-flex>
      <v-container class="" v-if="currSubStep === 2">
        <!-- month selection START -->
        <template v-if="trigger.freq_choice==='YEAR'"> 
          <span>Month and day</span>
          <v-select 
            v-on:input="updateTrigger('changedMonth')"
            :items="months"
            v-model="monthSelect"
            placeholder="Month"
            single-line
            item-text="text"
            item-value="text"
            return-object>
          </v-select>
        </template>
        <!-- month selection END -->

        <!-- date selection START -->
        <template v-if="trigger.freq_choice==='MONTH' || trigger.freq_choice==='YEAR'"> 
          <span v-if="trigger.freq_choice==='MONTH'">Day of the month</span>
          <v-select 
            v-on:input="updateTrigger('changedDate')"
            :items="dates"
            v-model="dateSelect"
            placeholder="Day"
            single-line
            item-text="text"
            item-value="text"
            return-object>
          </v-select>
        </template>
        <!-- date selection END -->

        <!-- hour selection START -->
        <template v-if="trigger.freq_choice!='HOUR'"> 
          <span>Time of day</span>
          <v-select 
            v-on:input="updateTrigger('changedHour')"
            :items="hours"
            v-model="hoursSelect"
            placeholder="Hour"
            single-line
            item-text="text"
            item-value="text"
            return-object>
          </v-select>
        </template>
        <!-- hour selection END -->

        <!-- minute selection START -->
        <template>
          <span v-if="trigger.freq_choice==='HOUR'">Minutes past the hour</span>
          
          <v-select 
            v-on:input="updateTrigger('changedMinutes')"
            :items="minutes"
            v-model="minutesSelect"
            label="Minutes"
            single-line
            item-text="text"
            item-value="hint"
            return-object>
          </v-select>
        </template>
        <!-- minute selection END -->

        <!-- day of week selection START -->
        <template v-if="trigger.freq_choice==='WEEK'">
          <span>Days of the week</span><br>
          <v-btn class="mr-1 mt-1"
          v-for="day in this.days" 
          :key="day.id"
           small fab :color="myColors[day.active*1]" @click.native="checkedDay(day.id)">{{day.text[0]+day.text[1]+day.text[2]}}</v-btn>
        </template>
        <!-- day of week selection END -->
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
  export default {
    data() {
      return {
        currSubStepInCron: this.currSubStep,
        myColors: ['default', 'primary'],
        minutesSelect: {},
        hoursSelect: {},
        daysSelect:[],
        dateSelect:{},
        monthSelect:{},
        minutes: [
        { text: '00 minutes', value: '00' },
        { text: '15 minutes', value: '15' },
        { text: '30 minutes', value: '30' },
        { text: '45 minutes', value: '45' },
        ],
        hours: [
        { text: '12 AM', value: '00' },
        { text: '01 AM', value: '01' },
        { text: '02 AM', value: '02' },
        { text: '03 AM', value: '03' },
        { text: '04 AM', value: '04' },
        { text: '05 AM', value: '05' },
        { text: '06 AM', value: '06' },
        { text: '07 AM', value: '07' },
        { text: '08 AM', value: '08' },
        { text: '09 AM', value: '09' },
        { text: '10 AM', value: '10' },
        { text: '11 AM', value: '11' },
        { text: '12 PM', value: '12' },
        { text: '01 PM', value: '13' },
        { text: '02 PM', value: '14' },
        { text: '03 PM', value: '15' },
        { text: '04 PM', value: '16' },
        { text: '05 PM', value: '17' },
        { text: '06 PM', value: '18' },
        { text: '07 PM', value: '19' },
        { text: '08 PM', value: '20' },
        { text: '09 PM', value: '21' },
        { text: '10 PM', value: '22' },
        { text: '11 PM', value: '23' },
        ],
        days: [
        { id: 0, text: 'Monday', value:'MON', active: false},
        { id: 1, text: 'Tuesday', value:'TUE', active: false },
        { id: 2, text: 'Wednesday', value:'WED', active: false },
        { id: 3, text: 'Thursday', value:'THU', active: false },
        { id: 4, text: 'Friday', value:'FRI', active: false },
        { id: 5, text: 'Saturday', value:'SAT', active: false },
        { id: 6, text: 'Sunday', value:'SUN', active: false },
        ],
        dates: [
        { text: '1st', value: '01' },
        { text: '2nd', value: '02' },
        { text: '3rd', value: '03' },
        { text: '4th', value: '04' },
        { text: '5th', value: '05' },
        { text: '6th', value: '06' },
        { text: '7th', value: '07' },
        { text: '8th', value: '08' },
        { text: '9th', value: '09' },
        { text: '10th', value: '10' },
        { text: '11th', value: '11' },
        { text: '12th', value: '12' },
        { text: '13th', value: '13' },
        { text: '14th', value: '14' },
        { text: '15th', value: '15' },
        { text: '16th', value: '16' },
        { text: '17th', value: '17' },
        { text: '18th', value: '18' },
        { text: '19th', value: '19' },
        { text: '20th', value: '20' },
        { text: '21th', value: '21' },
        { text: '22th', value: '22' },
        { text: '23th', value: '23' },
        { text: '24th', value: '24' },
        { text: '25th', value: '25' },
        { text: '26th', value: '26' },
        { text: '27th', value: '27'},
        { text: '28th', value: '28' },
        { text: '2 days before the last day', value: '-2' },
        { text: '1 day before the last day', value: '-1' },
        { text: 'Last day of the month', value: '00' },
        ],
        months: [
        { text: 'January', value: 'JAN' },
        { text: 'February', value: 'FEB' },
        { text: 'March', value: 'MAR' },
        { text: 'April', value: 'APR' },
        { text: 'May', value: 'MAY' },
        { text: 'June', value: 'JUN' },
        { text: 'July', value: 'JUL' },
        { text: 'August', value: 'AUG' },
        { text: 'September', value: 'SEP' },
        { text: 'October', value: 'OCT' },
        { text: 'November', value: 'NOV' },
        { text: 'December', value: 'DEC' },
        ],
      }
    },
    components: {
    },
    props: {
      trigger: {},
      cardInfo: {
        type: Object,
        default: () => {
          return {
          }
        }
      },
      currSubStep: Number,
    },
    watch: {
      currSubStep: function () {
        this.currSubStepInCron=this.currSubStep
      },
    },
    methods: {
      checkedDay(dayInList){
        this.days[dayInList].active=!this.days[dayInList].active;
        this.daysSelect=[];
        for (var i=0; i < this.days.length; i++){
          if(this.days[i].active===true){
            this.daysSelect.push(this.days[i].value);
          }
        }
        this.updateTrigger('changedDay')
      },
      updateTrigger(typeOfChange){
        switch (typeOfChange) {
          case 'changedMinutes':
            this.trigger.minute_choice=this.minutesSelect.value
            break;
          case 'changedHour':
            this.trigger.hour_choice=this.hoursSelect.value
            break;
          case 'changedDay':
            this.trigger.day_choice=this.daysSelect
            break;
          case 'changedDate':
            this.trigger.date_choice=this.dateSelect.value
            break;
          case 'changedMonth':
            this.trigger.month_choice=this.monthSelect.value
            break;
        }
        this.$emit('sendTriggerState', this.trigger)
      },
    },
    mounted: function() {
      if(typeof this.trigger.minute_choice !== 'undefined'){
        this.minutesSelect= this.minutes.find(x => x.value === this.trigger.minute_choice)
      }
      if(typeof this.trigger.hour_choice !== 'undefined'){
        this.hoursSelect= this.hours.find(x => x.value === this.trigger.hour_choice)
      }
      if(typeof this.trigger.day_choice !== 'undefined' && this.trigger.day_choice.length > 0){
        for (var i=0; i < this.trigger.day_choice.length; i++){
          for (var j=0; j < this.days.length; j++){
            if(this.trigger.day_choice[i]==this.days[j].value){
              this.days[j].active=true
              this.daysSelect.push(this.days[j].value);
            }
          }
        }
      }
      if(typeof this.trigger.date_choice !== 'undefined'){
        this.dateSelect= this.dates.find(x => x.value === this.trigger.date_choice)
      }
      if(typeof this.trigger.month_choice !== 'undefined'){
        this.monthSelect= this.months.find(x => x.value === this.trigger.month_choice)
      }
    },
  }
</script>